module.exports = __webpack_public_path__ + "img/Speaker=Jonathan Pavan.09bd89b7.png";